module.exports = __webpack_public_path__ + "static/media/loader2.0c7c8d61.svg";